import React from 'react';
import {styled} from '@mui/material/styles';
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";


const StyledTableCell = styled(TableCell)(({theme, center}) => ({
    ...(center && { textAlign: 'center' }),
}));

const StyledBox = styled(Box)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
}));


export default function CenterTableCell({centerText, align, children, ...otherProps}) {

    return (
        <StyledTableCell center={centerText ? 1 : 0} align={align} {...otherProps}>
            <StyledBox>
                {children}
            </StyledBox>
        </StyledTableCell>
    );
}

CenterTableCell.defaultProps = {
    centerText: false,
    align: 'left',
};
